export const enum LanguageCode {
    DA = 'DA',
    EN = 'EN',
    FI = 'FI',
    NO = 'NO',
    SV = 'SV',
}

export const toLanguageCode = (languageCode: string): LanguageCode => {
    if (languageCode && languageCode.toUpperCase() === 'DA') {
        return LanguageCode.DA;
    }
    if (languageCode && languageCode.toUpperCase() === 'FI') {
        return LanguageCode.FI;
    }
    if (languageCode && languageCode.toUpperCase() === 'NO') {
        return LanguageCode.NO;
    }
    if (languageCode && languageCode.toUpperCase() === 'SV') {
        return LanguageCode.SV;
    }
    return LanguageCode.EN;
};
